var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "icon bike",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.68 2a.828.828 0 0 1 .705.42l2.447 4.508A4.052 4.052 0 0 1 12.8 6.8 3.2 3.2 0 1 1 9.6 10a3.165 3.165 0 0 1 1.178-2.48l-.543-1-2.117 3.585a.6.6 0 0 1-.518.295H6.375A3.194 3.194 0 1 1 3.98 6.9l.665-1.328-.553-.772H3a.6.6 0 1 1 0-1.2h1.4a.686.686 0 0 1 .488.227l.685.972h3.734l-.865-1.6h-.664a.6.6 0 0 1 0-1.2zM11 10a1.8 1.8 0 1 0 1.8-1.8 1.739 1.739 0 0 0-.28.022l.807 1.493a.6.6 0 0 1-1.055.57l-.808-1.493A1.789 1.789 0 0 0 11 10zm-8.28-.585.608-1.21h-.15a1.8 1.8 0 1 0 1.777 2.2H3.33a.674.674 0 0 1-.61-.985zM7.257 9.2 5.435 6.67 4.17 9.2zM6.435 6l1.49 2.07L9.147 6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBikeIcon);
export default __webpack_public_path__ + "static/media/bike-icon.50ca8ff79b51302ebe8b5cf8c08dbbdb.svg";
export { ForwardRef as ReactComponent };